"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartExpressPaymentClick = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
const expressPayLabelMapping = {
    [enums_1.EventLabelCartButtonClickEnum.PaypalExpress]: 'paypal express',
    [enums_1.EventLabelCartButtonClickEnum.AmazonPayExpress]: 'amazon express',
    [enums_1.EventLabelCartButtonClickEnum.GooglePayExpress]: 'google express',
    [enums_1.EventLabelCartButtonClickEnum.ApplePayExpress]: 'apple express',
};
function trackCartExpressPaymentClick(label, clickElementText, clickText) {
    const clickedPaymentMethod = expressPayLabelMapping[label];
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: enums_1.ClickEventType.BUTTON_CLICK,
        eventLabel: label,
        eventData: {
            eventName: enums_1.GA4EventName.ClickExpressPayment,
            feature_category: enums_1.GA4FeatureCategory.Cart,
            click_element: clickElementText,
            click_text: clickText,
            ...(clickedPaymentMethod
                ? {
                    payment_method: clickedPaymentMethod,
                }
                : {}),
        },
    });
}
exports.trackCartExpressPaymentClick = trackCartExpressPaymentClick;
//# sourceMappingURL=trackCartExpressPaymentClick.js.map